"use client"

import { ArrowUp } from "lucide-react"

export default function BackToTop() {
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      className="flex items-center justify-center w-9 h-9 rounded-md bg-brand-navy text-white hover:bg-brand-navy/90 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-brand-navy focus-visible:ring-offset-2"
    >
      <ArrowUp className="w-4 h-4" aria-hidden="true" />
    </button>
  )
}
